const UUIDKey = 'teacher-UUID-key'

export function getUUID() {
  return localStorage.getItem(UUIDKey)
}

export function setUUID(uuid) {
  localStorage.setItem(UUIDKey, uuid)
}
